import * as React from "react";

export const FASSUNG_HINWEIS =
    "Kommentare beziehen sich evtl. auf eine andere Fassung — die Seitenzahl hat sich geändert.";

/**
 * Nach „Fassung wiederherstellen“: Kommentare hängen an Seitennummern. Hat die
 * wiederhergestellte Fassung eine andere Seitenzahl, stehen sie womöglich an
 * falschen Stellen — das soll man erfahren.
 *
 * `merke()` VOR dem Neuladen aufrufen. Verglichen wird erst, wenn die
 * Seitenzahl einmal unbekannt (`null`, Viewer lädt neu) und danach wieder
 * bekannt war — sonst verglichen wir die alte Fassung mit sich selbst.
 */
export function useFassungsHinweis(seitenzahl: number | null): { merke: () => void; hinweis: string | null } {
    const [hinweis, setHinweis] = React.useState<string | null>(null);
    const aktuell = React.useRef(seitenzahl);
    aktuell.current = seitenzahl;
    const warte = React.useRef<{ vorher: number; neuGeladen: boolean } | null>(null);

    const merke = React.useCallback(() => {
        setHinweis(null);
        warte.current = aktuell.current === null ? null : { vorher: aktuell.current, neuGeladen: false };
    }, []);

    React.useEffect(() => {
        const w = warte.current;
        if (!w) return;
        if (seitenzahl === null) {
            w.neuGeladen = true;
            return;
        }
        if (!w.neuGeladen) return;
        warte.current = null;
        if (seitenzahl !== w.vorher) setHinweis(FASSUNG_HINWEIS);
    }, [seitenzahl]);

    return { merke, hinweis };
}
